module.exports = __webpack_public_path__ + "static/media/ShipstonGallery.4bbb7ab4.png";